'use client'

import Link from 'next/link'

import { Button as MuiButton, styled } from '@mui/material'

import { getTarget } from '@/helpers/getTarget'
import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { Button as SanityButton } from '@/gen/sanity/schema'

const StyledButton = styled(MuiButton)({
  width: 'fit-content',
  a: {
    textDecoration: 'none',
    color: 'inherit',
  },
})

export const Button: React.FC<SanityButton> = (props) => {
  const { language } = useTranslations()
  const { externalName, openInNewTab, url, urlType } = props
  if (externalName && externalName[language]) {
    if (url && (urlType === 'relativeUrl' || urlType === 'absoluteUrl')) {
      return (
        <StyledButton variant="contained" id={props.internalName}>
          <a href={url} {...getTarget(openInNewTab)}>
            {externalName[language]}
          </a>
        </StyledButton>
      )
    }
    if (urlType === 'differentProtocolUrl') {
      return (
        <Link href={url ?? '#'}>
          <StyledButton variant="contained" id={props.internalName}>
            {externalName[language]}
          </StyledButton>
        </Link>
      )
    }
  }

  return null
}
